import { formattedMessageSentAt } from "@circle-react/helpers/dateTimeHelpers/formattedMessageSentAt";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

interface StaticEditedLabelProps {
  editedAt?: string | null;
}

export const StaticEditedLabel = ({ editedAt }: StaticEditedLabelProps) => {
  const { day, time } = formattedMessageSentAt(
    editedAt || new Date().toISOString(),
  );

  return (
    <TippyV2 content={`${day} at ${time}`} disabled={!editedAt}>
      <span style={{ color: "#717680" }} className="ml-0.5 cursor-default">
        {t("edited")}
      </span>
    </TippyV2>
  );
};
